import getServiceRequestsBySerialNumber from '~/api/getServiceRequestsBySerialNumber';
import axios from 'axios';

export const RequestsListBySerialNumber = {
	name: 'RequestsListBySerialNumber',
	props: {
		serialNumber: String,
		exclude: String,
	},
	data: () => ({
		items: [],
		loading: false,
	}),
	computed: {
		canShowItems: (vm) => !vm.loading && vm.items?.length > 0,
	},
	watch: {
		serialNumber: {
			handler: function() {
				// Abort previous request
				// this.$options.controller?.cancel('Request cancelled due to serial number change');
				this.items = [];

				if (!this.serialNumber) {
					this.loading = false;
				}

				this.loading = true;

				this.$options.controller = new AbortController();

				getServiceRequestsBySerialNumber(this.serialNumber, this.exclude)
					.then(({ items }) => {
						this.items = items;
						this.loading = false;
					})
					.catch(() => null);
			},
			immediate: true,
		},
	},
	destroyed() {
		this.$options.controller?.abort();
	},
	render() {
		return (
			<div>
				{ this.loading ? (
					'Поиск повторных ремонтов...'
				) : null }

				{ this.canShowItems ? [
					<b>Повторный ремонт:</b>,
					' ',
					this.items.map((item, index) => [
						index > 0 ? ', ' : null,
						item.CAN_OPEN ? (
							<a class="request-edit-link" href={ item.URL } target="_blank">
								{ item.NAME }
							</a>
						) : (
							<span>
								{ item.NAME }
							</span>
						)
					])
				] : null }
			</div>
		)
	}
}
